import {isLgs} from 'common/HelperFunctions'

/**
 * Whether the native React fee page serves the logged-in student/parent.
 * LGS keeps its own fee integration (`/fee` and `/site/lgsFee`); every other
 * tenant gets the native page (the legacy `/finance/finance/view` iframe is
 * redirected to it).
 */
export const isNewFeePageEnabled = () => !isLgs()

/** Path of the student/parent fee section for the current tenant. */
export const getStudentFeePath = () =>
  isNewFeePageEnabled() ? '/fee/vouchers' : '/finance/finance/view/0'
